import React from 'react';
import { Button } from '@sm360/ui-library';
import { LocaleService } from '@sm360/widget-commons-core-services';
import 'trade-in/components/InstantEstimateWrapper/Components/ActionButton/ActionButton.scss';

const ActionButton = ({
    next = false,
    noPrefix = false,
    noArrow = false,
    noSubmit = false,
    selected = false,
    loading = false,
    disabled = false,
    checkedIcon = false,
    children,
    ...buttonProps
}) => {
    const nextPrefix = `${LocaleService.t('TRADE_IN.BUTTONS.NEXT')}: `;
    const prevPrefix = `${LocaleService.t('TRADE_IN.BUTTONS.PREVIOUS')}: `;

    return (
        <section
            className={`clearfix vehicle-buttons${next ? '--submit' : '--previous'} ${selected ? 'pressed' : ''}`}
            data-test="trade-in.vehicle-form.submit"
        >
            <Button type={next && !noSubmit ? 'submit' : 'button'} disabled={loading || disabled} {...buttonProps}>
                <span className={`${next ? 'uk-button--text' : 'uk-button--arrow'} ${loading && 'loading'}`}>
                    {checkedIcon && <icon className="icon-radio-button-on" />}
                    {!loading && (next ? `${!noPrefix ? nextPrefix : ''} ${children}` : !noArrow && '<')}
                </span>
                <span className={next ? 'uk-button--arrow' : 'uk-button--text'}>
                    {!loading && (next ? !noArrow && '>' : `${!noPrefix ? prevPrefix : ''} ${children}`)}
                </span>
            </Button>
        </section>
    );
};

ActionButton.displayName = 'ActionButton';

export default ActionButton;
